(function () {
    function safeInit(initializer, element) {
        if (!initializer || !element || typeof initializer.init !== 'function') {
            return;
        }

        try {
            initializer.init(element);
        } catch (error) {
            console.warn('filadelfia theme module failed to initialize.', {
                element: element,
                initializer: initializer,
                error: error
            });
        }
    }

    function initNodeList(nodeList, initializer) {
        if (!initializer || !nodeList.length) {
            return;
        }

        nodeList.forEach(function (element) {
            safeInit(initializer, element);
        });
    }

    function initThemeModules() {
        var bannerSliderElements = document.querySelectorAll('[data-banner-slider]');
        var homeProductSliderElements = document.querySelectorAll('[data-home-product-slider]');
        var homeCategoriesSliderElements = document.querySelectorAll('[data-home-categories-slider]');
        var homeOfferSliderElements = document.querySelectorAll('[data-home-offer-slider]');
        var homeInstagramElements = document.querySelectorAll('[data-home-instagram]');
        var homeReviewsElements = document.querySelectorAll('[data-home-reviews]');
        var headerElement = document.querySelector('[data-site-header]');
        var mainCollectionElements = document.querySelectorAll('[data-main-collection]');
        var secondSectionElements = document.querySelectorAll('[data-second-section]');
        var productHeroElements = document.querySelectorAll('[data-product-hero]');
        var productReviewsElements = document.querySelectorAll('[data-product-reviews]');
        var productRelatedElements = document.querySelectorAll('[data-product-related]');
        var siteFooterElements = document.querySelectorAll('[data-site-footer]');
        var stickyAtcElements = document.querySelectorAll('[data-sticky-atc]');

        initNodeList(bannerSliderElements, window.filadelfiaBannerSlider);
        initNodeList(secondSectionElements, window.filadelfiaSecondSection);
        initNodeList(homeCategoriesSliderElements, window.filadelfiaHomeCategoriesSlider);
        initNodeList(homeProductSliderElements, window.filadelfiaHomeFeaturedCollection);
        initNodeList(homeOfferSliderElements, window.filadelfiaHomeOfferBanner);
        initNodeList(homeInstagramElements, window.filadelfiaHomeInstagram);
        initNodeList(homeReviewsElements, window.filadelfiaHomeReviews);

        if (window.filadelfiaSiteHeader && headerElement) {
            safeInit(window.filadelfiaSiteHeader, headerElement);
        }

        if (window.filadelfiaCartDrawer && headerElement) {
            safeInit(window.filadelfiaCartDrawer, headerElement);
        }

        initNodeList(mainCollectionElements, window.filadelfiaMainCollection);
        initNodeList(productHeroElements, window.filadelfiaProductHero);
        initNodeList(productReviewsElements, window.filadelfiaJudgeMe);
        initNodeList(productRelatedElements, window.filadelfiaProductRelated);
        initNodeList(siteFooterElements, window.filadelfiaSiteFooter);
        initNodeList(stickyAtcElements, window.filadelfiaStickyAtc);
    }

    function initWithinTarget(target) {
        if (!target) {
            return;
        }

        initNodeList(target.querySelectorAll('[data-banner-slider]'), window.filadelfiaBannerSlider);
        initNodeList(target.querySelectorAll('[data-second-section]'), window.filadelfiaSecondSection);
        initNodeList(target.querySelectorAll('[data-home-categories-slider]'), window.filadelfiaHomeCategoriesSlider);
        initNodeList(target.querySelectorAll('[data-home-product-slider]'), window.filadelfiaHomeFeaturedCollection);
        initNodeList(target.querySelectorAll('[data-home-offer-slider]'), window.filadelfiaHomeOfferBanner);
        initNodeList(target.querySelectorAll('[data-home-instagram]'), window.filadelfiaHomeInstagram);
        initNodeList(target.querySelectorAll('[data-home-reviews]'), window.filadelfiaHomeReviews);
        if (window.filadelfiaSiteHeader) {
            var siteHeaderElement = target.matches && target.matches('[data-site-header]')
                ? target
                : target.querySelector && target.querySelector('[data-site-header]');

            if (siteHeaderElement) {
                safeInit(window.filadelfiaSiteHeader, siteHeaderElement);
            }
        }
        if (window.filadelfiaCartDrawer) {
            var headerElement = target.matches && target.matches('[data-site-header]')
                ? target
                : target.querySelector && target.querySelector('[data-site-header]');

            if (headerElement) {
                safeInit(window.filadelfiaCartDrawer, headerElement);
            }
        }
        initNodeList(target.querySelectorAll('[data-main-collection]'), window.filadelfiaMainCollection);
        initNodeList(target.querySelectorAll('[data-product-hero]'), window.filadelfiaProductHero);
        if (window.filadelfiaJudgeMe) {
            var productReviewsElement = target.matches && target.matches('[data-product-reviews]')
                ? target
                : target.querySelector && target.querySelector('[data-product-reviews]');

            if (productReviewsElement) {
                safeInit(window.filadelfiaJudgeMe, productReviewsElement);
            }
        }
        initNodeList(target.querySelectorAll('[data-product-related]'), window.filadelfiaProductRelated);
        initNodeList(target.querySelectorAll('[data-site-footer]'), window.filadelfiaSiteFooter);
        initNodeList(target.querySelectorAll('[data-sticky-atc]'), window.filadelfiaStickyAtc);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initThemeModules);
    } else {
        initThemeModules();
    }

    window.addEventListener('load', initThemeModules);
    window.setTimeout(initThemeModules, 600);

    document.addEventListener('shopify:section:load', function (event) {
        initWithinTarget(event.target);
    });
})();
